(() => {
  const minimumDelay = 25000;
  const releaseAfter = Date.now() + minimumDelay;
  const originalDisplays = new WeakMap();
  let released = false;

  const cookieBannerIsVisible = () => {
    const banner = document.querySelector('#cookies-wrapper');
    if (!banner) return false;

    const styles = window.getComputedStyle(banner);
    return styles.display !== 'none' && styles.visibility !== 'hidden' && banner.getClientRects().length > 0;
  };

  const newsletterForms = () => document.querySelectorAll('shopify-forms-embed');

  const holdNewsletter = (form) => {
    if (!originalDisplays.has(form)) {
      originalDisplays.set(form, {
        display: form.style.getPropertyValue('display') || 'block',
        priority: form.style.getPropertyPriority('display'),
      });
    }

    if (form.style.getPropertyValue('display') !== 'none') {
      form.style.setProperty('display', 'none', 'important');
    }
  };

  const releaseNewsletter = (form) => {
    const original = originalDisplays.get(form) || { display: 'block', priority: '' };
    form.style.setProperty('display', original.display, original.priority);
  };

  const coordinatePopups = () => {
    const forms = newsletterForms();
    if (!forms.length) return;

    if (Date.now() < releaseAfter || cookieBannerIsVisible()) {
      forms.forEach(holdNewsletter);
      return;
    }

    if (!released) {
      released = true;
      forms.forEach(releaseNewsletter);
      observer.disconnect();
      window.clearInterval(checkInterval);
    }
  };

  const observer = new MutationObserver(coordinatePopups);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class'],
  });

  const checkInterval = window.setInterval(coordinatePopups, 300);
  coordinatePopups();
})();
